var _ = require('lodash');
var dd = require('react-dd');
var FormInputMixin = require('../FormInputMixin');

var component = dd.createClass({
	mixins: [FormInputMixin],
	__onChange: function(e){
		this._input_newValue(e.target.value);
	},
	render: function(){
		var field = this.props.field;
		var value = this.props.value;

		if(field.read_only){
			return dd.p({className: 'form-control-static'},
				value
			);
		}

		var p = {
			type: field.type || 'text',
			placeholder: field.placeholder || null,
			className: 'form-control',
			value: value || '',
			name: this.props.field_path,
			onChange: this.__onChange
		};
		if(p.type === "number"){
			_.each(["min", "max", "step"], function(key){
				if(_.has(field, key) && _.isNumber(field[key])){
					p[key] = field[key];
				}
			});
		}
		return dd.input(p);
	}
});

module.exports = {
	component: component
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/Text.js
// module id = 202
// module chunks = 0 1 2 3 4